import EVMBase from './EVMBase';
import type ExplorerRootStore from '../../ExplorerRootStore';
import { Provider } from '../../types';

export interface Eip6963ProviderInfo {
	uuid: string;
	name: string;
	icon: string;
	rdns: string;
}

interface Eip6963ProviderDetail {
	info: Eip6963ProviderInfo;
	provider: Provider;
}

const nameMap = {
	'io.metamask': 'metamask',
	'app.backpack': 'backpack',
	'com.brave.wallet': 'brave',
	'com.coinbase.wallet': 'coinbase',
	'app.phantom': 'phantom',
} as Record<string, string>;

export default class EIPWallet extends EVMBase {
	name: string = '';
	icon = '';
	info = undefined;
	website = '';
	id: string = '';

	get disconnectable(): boolean {
		return false;
	}

	constructor(root: ExplorerRootStore, details: Eip6963ProviderDetail) {
		const id = details.info.rdns;
		const supported = root.configs.filters[nameMap[id] as keyof typeof root.configs.filters];
		super(supported);
		this.id = details.info.rdns;
		this.name = details.info.name;
		this.icon = details.info.icon;
		this.cachedInjectedProvider = details.provider;
	}

	loadEthereum() {
		return this.cachedInjectedProvider;
	}

	disconnect(): Promise<void> {
		throw new Error('Method not implemented.');
	}
}